<div class="content_main-container">
  <ng-container *ngrxLet="defaultSavingAccountId$ as defaultSavingAccountId">
    <h1 id="payment-page-title">
      {{ (isOrderReview ? '' : 'CHECKOUT.CREATE_PROFILE.PAYMENT_METHOD.TITLE') | translate }}
    </h1>
    @if (!isOrderReview) {
    <div>
      <small class="mat-body-2 block mt-11" id="checkout_payment-method_subtitle">{{
        'CHECKOUT.CREATE_PROFILE.PAYMENT_METHOD.SUBTITLE' | translate
        }}</small>
    </div>
    } @if (isReturningUser) {
    <div>
      <pbb-link-bank *ngrxLet="email$ as email" [email]="email"></pbb-link-bank>
    </div>
    }
    <div class="notifications">
      @if (errorMessage) {
      <pbb-notice id="order-review_payment-method-error-message" [type]="noticeType.ERROR" [title]="errorMessage"
        [subtitle]="errorSubtitle" [buttonText]="errorButtonText | translate"
        [buttonLink]="errorButtonLink"></pbb-notice>
      }
    </div>
    <ng-container *ngrxLet="defaultFiId$ as defaultFiId">
      <ng-container *ngrxLet="defaultAccountId$ as defaultAccountId">
        <div class="content_main-fi-group" *ngrxLet="userProfile$ as userProfile">
          <pbb-payment-method-list id="manage-payment-methods-list" [userProfile]="userProfile?.data"
            [(ngModel)]="selectedAccount" [defaultSelectedAccount]="defaultAccountId"
            (setDefault)="setDefaultPaymentMethod($event)"
            [isCheckout]="true"
            [displayButtons]="false"
            (ngModelChange)="updatePaymentMethod($event)"></pbb-payment-method-list>
        </div>
      </ng-container>
    </ng-container>
  </ng-container>
  <div appStickyButton="#footer" class="sticky-container">
    <div class="sticky-main">
      <pbb-button
          [size]="'L'" id="btn-continue"  [disabled]="!selectedAccount" (clicked)="onClickContinue()">
        {{ 'COMMON.BUTTON.CONTINUE' | translate }}
      </pbb-button>
    </div>
  </div>
</div>